import { List, TextField, useTable } from "@refinedev/antd";
import { Table, Space } from "antd";
import { errorNotification, safeDayjs } from "../../../helpers";
import { VideoAdd } from "./Video-Add";
import { VideoDelete } from "./Video-Delete";
import { VideoEdit } from "./Video-Edit";
import { useContext } from "react";
import { EnvContext } from "providers";
import { s3Path } from "helpers";
import { leagueMap } from "../leagueOptions";

export type VideoType = {
  id: number;
  name: string;
  link: string;
  leagueId: number;
  date: string;
  img: string;
};

export const VideoList = () => {
  const { THUMBOR_URL } = useContext(EnvContext);
  const { tableProps } = useTable<VideoType>({
    dataProviderName: "videoDataProvider",
    resource: "video",
    syncWithLocation: false,
    queryOptions: {
      enabled: true,
    },
    ...errorNotification({}),
  });

  return (
    <List
      title={"Видео"}
      resource={"video"}
      breadcrumb={false}
      canCreate={false}
      headerButtons={<VideoAdd />}
    >
      <Table {...tableProps} rowKey="id" pagination={false}>
        <Table.Column<VideoType>
          dataIndex="img"
          title="Превью"
          render={(value) =>
            value ? (
              <img
                src={s3Path({
                  path: value,
                  original: true,
                  thumbor: THUMBOR_URL,
                })}
                style={{ width: 120 }}
              />
            ) : null
          }
        />
        <Table.Column<VideoType>
          dataIndex="name"
          title="Название"
          render={(value) => <TextField value={value} />}
        />
        <Table.Column<VideoType>
          dataIndex="link"
          title="Ссылка"
          render={(value) => <TextField value={value} />}
        />
        <Table.Column<VideoType>
          dataIndex="leagueId"
          title="Лига"
          render={(value) => <TextField value={leagueMap[Number(value)]} />}
        />
        <Table.Column<VideoType>
          dataIndex="date"
          title="Дата"
          render={(value) => {
            const formattedDate = value
              ? safeDayjs(value)?.format("DD.MM.YYYY HH:mm") || ""
              : "";
            return <TextField value={formattedDate} />;
          }}
        />
        <Table.Column<VideoType>
          title="Действия"
          render={(_, record) => (
            <Space>
              <VideoEdit record={record} />
              <VideoDelete id={record.id} name={record.name} />
            </Space>
          )}
        />
      </Table>
    </List>
  );
};
